import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Tabs, Tab } from 'react-bootstrap';

import { Link } from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import Select from 'react-select';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import InputMask from 'react-input-mask';

// Tabs
import PaymentCheckbox from './PaymentCheckbox';

class PaymentDailyOpened extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      key: 1,
      loaded: 0,
      payment_checks: [],
      payment_orders_list: [],
      staffs_select: [],
      checkbox_marked_ids: [],
      data_payment_daily: [],
      check_all_payments: false,
      props_payment_checked: false,
      checkbox_changed: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.PaymentCheckbox = this.PaymentCheckbox.bind(this);
    this.unmarkAllCheckbox = this.unmarkAllCheckbox.bind(this);
    this.markAllCheckbox = this.markAllCheckbox.bind(this);
    this.markedCheckboxId = this.markedCheckboxId.bind(this);
    this.UnmarkCheckboxId = this.UnmarkCheckboxId.bind(this);
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
    this.addPayment = this.addPayment.bind(this);
    this.duplicate = this.duplicate.bind(this);
  }
  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  handleCheckboxChange(name, event) {
    // valor selecionado. Valor são true e false
    var value = event.target.checked;
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = value;
      if (value) {
        this.markAllCheckbox();
      } else {
        this.unmarkAllCheckbox();
      }
    }
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/pagamentos/abertos/diarias/cheques';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({payment_checks: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/ordens/pagamento/lista/treinamentos';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
            self.setState({payment_orders_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/colaboradores/ativos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({staffs_select: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */  }); /* Lista de ordens de pagamento diarias nacionais */ }); /* Lista de Colaboradors */
    });
  }

  refreshTable(event) {
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/pagamentos/abertos/diarias/cheques';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({payment_checks: responseJson.data});
        }
        self.handleAlert(event.message, event.status, 'open');
        self.unmarkAllCheckbox();
        self.modalPropsOff();
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      checkbox_marked_ids: this.state.checkbox_marked_ids,
      payment_order_id: this.state.payment_order_id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/ordem/pagamento/incluir/pagamentos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.refreshTable(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addPayment(event) {
    event.preventDefault();
    var datasave = {
      staff_id: this.state.staff_id,
      value: this.state.value,
      checked_id: this.state.checked_id,
      date_start: this.state.date_start,
    };
    this.handleAlert('', '', 'open');
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento/cheque/adicionar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.refreshTable(responseJson);
        } else {
          this.handleAlert('', '', 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  duplicate(id) {
    var datasave = {
      id: id,
    };
    this.handleAlert('', '', 'open');
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento/cheque/duplicar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.refreshTable(responseJson);
        } else {
          this.handleAlert('', '', 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

    delete(event) {
      event.preventDefault();
      var confirm = window.confirm('Tem certeza que gostaria de deletar os pagamentos selecionados?');
      if (confirm) {
        var datasave = {
          checkbox_marked_ids: this.state.checkbox_marked_ids,
        };
        var self = this;
        var header = this.refs.request_api.header('application/json');
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/deletar/pagamentos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            if (responseJson.status === 'success') {
              self.refreshTable(responseJson);
            } else {
              self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
            }
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    }

    ActionsButtons (cell, row) {
      var url = "";
      var botao = (
        <div className="btn-group">
          <button onClick={() => this.duplicate(cell)} className='btn btn-sm btn-warning' alt='Duplicar' title='Duplicar'><i className="fa fa-fw fa-refresh"></i></button>
        </div>
      );

      return botao;
    }

    PaymentCheckbox (cell, row) {
      var botao = (
        <div>
          <PaymentCheckbox handleAlert={this.handleAlert} markedCheckboxId={this.markedCheckboxId} UnmarkCheckboxId={this.UnmarkCheckboxId} checkbox_marked_ids={this.state.checkbox_marked_ids} training_certification_staff_payment_id={cell} />
        </div>
      );

      return botao;
    }

    unmarkAllCheckbox () {
      this.setState({checkbox_marked_ids: []});
    }

    markAllCheckbox () {
      var self = this;
      var ids_temp = [];
      Object.keys(self.state.payment_checks).map(function(k) {
        ids_temp.push(self.state.payment_checks[k].id);
      });
      self.setState({checkbox_marked_ids: ids_temp});
    }

    markedCheckboxId (value) {
      var ids_temp = this.state.checkbox_marked_ids;
      ids_temp.push(value);
      this.setState({checkbox_marked_ids: ids_temp});
    }

    UnmarkCheckboxId (value) {
      var self = this;
      var ids_temp = [];
      var checkbox_ids = this.state.checkbox_marked_ids;
      checkbox_ids.map(function(checked_id) {
        if(checked_id !== value) {
          ids_temp.push(checked_id);
        }
      });
      self.setState({checkbox_marked_ids: ids_temp});
    }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">Pagamentos em aberto - Cheques</h3>
      <hr/>
      <form onSubmit={this.addPayment}>
        <div className={'row'}>
          <div className={'col-md-3 form-group'}>
            <div className="form-group">
              <label>Examinador:</label>
              <Select
                className="form-field-name"
                name="staff_id"
                value={this.state.staff_id}
                searchable={true}
                placeholder={'Selecione o funcionário'}
                onChange={this.handleSelectChange.bind(this, 'staff_id')}
                options={this.state.staffs_select}
              />
            </div>
          </div>
          <div className={'col-md-3 form-group'}>
            <div className="form-group">
              <label>Checado:</label>
              <Select
                className="form-field-name"
                name="checked_id"
                value={this.state.checked_id}
                searchable={true}
                placeholder={'Selecione o funcionário'}
                onChange={this.handleSelectChange.bind(this, 'checked_id')}
                options={this.state.staffs_select}
              />
            </div>
          </div>
          <div className={'col-md-3 form-group'}>
            <div className="form-group">
              <label>Data:</label>
              <InputMask value={this.state.date_start}  maskChar={null} name="date_start " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" required />
            </div>
          </div>
          <div className={'col-md-3 form-group'}>
            <div className="form-group">
              <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-plus"></i> Adicionar</button>
            </div>
          </div>
        </div>
      </form>
      <form onSubmit={this.add}>
          <div className="form-group">
            <label>Ordem de pagamento:</label>
            <Select
              className="form-field-name"
              name="payment_order_id"
              value={this.state.payment_order_id}
              searchable={true}
              placeholder={'Selecionar ordem de pagamento'}
              onChange={this.handleSelectChange.bind(this, 'payment_order_id')}
              options={this.state.payment_orders_list}
            />
          </div>
          <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-plus"></i> Adicionar a ordem de pagamento</button>
          <button type="button" onClick={this.delete} className="btn btn-danger btn-block"><i className="fa fa-fw fa-trash"></i> Deletar pagamentos</button>
      </form>
      <hr/>
      <BootstrapTable data={this.state.payment_checks} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há pagamentos em aberto'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.PaymentCheckbox} width='30'>
        </TableHeaderColumn>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>Ações</TableHeaderColumn>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>
        <TableHeaderColumn dataField="staff" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Examinador</TableHeaderColumn>
        <TableHeaderColumn dataField="checked" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Checado</TableHeaderColumn>
        <TableHeaderColumn dataField="date_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data</TableHeaderColumn>
        <TableHeaderColumn dataField="canac" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Canac</TableHeaderColumn>
        <TableHeaderColumn dataField="inscription" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Matricula</TableHeaderColumn>
        <TableHeaderColumn dataField="daily_total" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Valor</TableHeaderColumn>
        <TableHeaderColumn dataField="daily_currency" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Moeda</TableHeaderColumn>
      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default PaymentDailyOpened;



// WEBPACK FOOTER //
// ./src/Components/TrainingCertificationStaffPayments/PaymentCheckOpened.js